import { render, staticRenderFns } from "./ModalDocHistory.vue?vue&type=template&id=e93fb4c8&"
import script from "./ModalDocHistory.vue?vue&type=script&lang=js&"
export * from "./ModalDocHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports